import type {
  QualificationCriteriaCategory,
  QualificationCriteriaQuestion,
} from '~/types/UserQualifications'

/**
 * Clé de groupe UI (chips « Comment je cherche ») → catégorie API DELETE.
 */
export const QUALIFICATION_CRITERIA_CATEGORY_BY_GROUP_KEY: Record<
  string,
  QualificationCriteriaCategory
> = {
  villes: 'Locations',
  pays: 'Locations',
  domaines: 'Interests',
  niveau: 'AcademicLevel',
  diplomes: 'Degrees',
  duree: 'Duration',
  styles: 'Styles',
  rentree: 'StartDate',
}

/** Options : liste `degrees` de `GET /api/Profile/qualification/referentials`, posée par le store. */
export const DEGREES_QUESTION: QualificationCriteriaQuestion = {
  key: 'degrees',
  category: 'Degrees',
  labelKey: 'chat.searchFilters.questions.degrees',
  lolaMessagePrefix: 'Voici le type de diplôme que je vise : ',
  isMultipleChoice: true,
  hasMultipleChoiceMention: true,
  options: [],
}

export const DURATION_QUESTION: QualificationCriteriaQuestion = {
  key: 'duration',
  category: 'Duration',
  labelKey: 'chat.searchFilters.questions.duration',
  lolaMessagePrefix: "Pour la durée de formation, j'aimerais bien : ",
  isMultipleChoice: false,
  hasMultipleChoiceMention: false,
  options: [
    { label: '2 ans', description: null },
    { label: '3 ans', description: null },
    { label: '5 ans', description: null },
    { label: 'Peu importe', description: null },
  ],
}

/** Options : liste `styles` de `GET /api/Profile/qualification/referentials`, posée par le store. */
export const STYLES_QUESTION: QualificationCriteriaQuestion = {
  key: 'styles',
  category: 'Styles',
  labelKey: 'chat.searchFilters.questions.styles',
  lolaMessagePrefix: "Pour le style d'apprentissage, je préfère : ",
  isMultipleChoice: true,
  hasMultipleChoiceMention: false,
  options: [],
}

export const START_DATE_QUESTION: QualificationCriteriaQuestion = {
  key: 'startDate',
  category: 'StartDate',
  labelKey: 'chat.searchFilters.questions.startDate',
  lolaMessagePrefix: 'Voici ma date de rentrée visée : ',
  isMultipleChoice: false,
  hasMultipleChoiceMention: false,
  options: [
    { label: 'Septembre 2026', description: null },
    { label: 'Janvier 2027', description: null },
    { label: 'Septembre 2027', description: null },
  ],
}
